module.exports = __webpack_public_path__ + "dist/images/0972b3c24ab39a19b761e4dce183ab2b.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/select-role/teacher.svg
// module id = 476
// module chunks = 0